export default {
  mediaByChannel: 'Media {kpi} by Channel',
  dataView: 'Data View',
  close: 'Close',
  refresh: 'Refresh',
  saveAsImage: 'Save as Image'
}
